import { Stack, Typography, useMediaQuery, useTheme } from "@mui/material";

/**
 * The header for the Clause Library table
 */
export const ClauseLibraryTableHeader = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    return (
        <Stack pb={1}>
            {/* Title */}
            <Typography
                variant={isMobile ? "h5" : "h4"}
                component="h1"
                sx={{
                    fontWeight: 700,
                    color: "#233876",
                    fontSize: "1.5rem",
                    mt: 1,
                    mb: 0.5,
                    wordWrap: "break-word",
                }}
            >
                Clause Library
            </Typography>
        </Stack>
    );
};
